// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__wnhib"};